// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#assistant-stawag-waerme-plus-gjuce .gc-multiple-choice .row{margin-top:0;margin-bottom:0}#assistant-stawag-waerme-plus-gjuce .gc-multiple-choice .v-text-field__details{display:none!important}", ""]);
// Exports
module.exports = exports;
